module.exports = __webpack_public_path__ + "img/孙开敏教授.eae7bae0.jpg";